import React from "react";
import { observer } from "mobx-react-lite";
import { useInput } from "@lib-shared/hooks";
import { Notice } from "components/common-ui";
import FormInput from "./form-input";
import LinkUpStore from "../link-up.store";

type CustomerSearchProps = {
    display: boolean,
    onSearch: any,
    onNotNow: any,
    cancellationToken?: any,
    store: LinkUpStore
}

const CustomerSearch = observer((props: CustomerSearchProps) => {
    const { display, onSearch, onNotNow, store } = props;

    const numericRegEx = /^[0-9]{3,}$/;

    const inputValidation = (value: string) => value.match(numericRegEx) != null;

    const customerNumberInput = useInput(inputValidation, { id: "customerNumber" });
    const smartCardNumberInput = useInput(inputValidation, { id: "smartCardNumber" });
    const registrationNumberInput = useInput(inputValidation, { id: "registrationNumber" });

    const fields = [customerNumberInput, smartCardNumberInput, registrationNumberInput];

    const numberOfFieldsWithValue = fields.filter(x => x.isValid).length;

    const isFormValid = numberOfFieldsWithValue === 1;

    const search = async (e: any) => {
        if (e != null) {
            e.preventDefault();
        }

        if (!isFormValid || store.isSearching) {
            return;
        }

        store.updateIsSearching(true);

        const input = fields.find(x => x.isValid);

        await onSearch(input.id, input.value);

        store.updateIsSearching(false);
    }

    const submitButtonCssName = !isFormValid ? " disabled" : "";

    if (display !== true) {
        return null;
    }

    return (
        <Notice className="customer-search floaty-form">
            <form>
                <h1>Linking your DStv Account</h1>

                {numberOfFieldsWithValue <= 1 ? null : (
                    <p>
                        Please only enter one type of number.
                    </p>
                )}

                <p>
                    Almost done! To connect to the correct account,
                    please provide your customer or smartcard number below:
                </p>

                <FormInput title="Customer Number" input={customerNumberInput} pattern="[0-9]{3,}" />

                <em>Or</em>

                <FormInput title="Smartcard Number" input={smartCardNumberInput} pattern="[0-9]{3,}" />

                {/* CEF api currently doesn't support searching by business registration number */}
                {/* <em>Or</em>

            <FormInput title="Business Registration Number" input={registrationNumberInput} pattern="[0-9]{3,}" /> */}

                {store.isSearching ?
                    <p className="processing">Searching</p> :
                    <button
                        className={`btn btn-black${submitButtonCssName}`}
                        disabled={!isFormValid}
                        onClick={search}>Find My DStv Package</button>}

                <span className="anchor action" onClick={onNotNow}>Not Now</span>
            </form>
        </Notice>
    );
});

export default CustomerSearch;
